import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { BetslipBetBuilderPick } from '../../../core/picks/betslip-bet-builder-pick';
import { BaseBetslipGroupPick } from '../../../core/picks/betslip-group-pick';
import { BetslipPick } from '../../../core/picks/betslip-pick';
import { BetslipMarketSubTypeLogoService } from '../../picks/services/betslip-market-sub-type-logo.service';
import { BetBuilderSelectionModel } from '../../single-bet/components/betbuilder-selection.model';
import { IBetslipPickErrors } from '../../validation/state';

export function getBetBuilderSelections(
    pick: BetslipPick,
    pickErrors: IBetslipPickErrors,
    betslipMarketSubTypeLogoService: BetslipMarketSubTypeLogoService,
): BetBuilderSelectionModel[] {
    if (BetslipBetBuilderPick.isPick(pick)) {
        return getBetBuilderPickSelections(pick);
    }

    if (BaseBetslipGroupPick.isPick(pick)) {
        return getPickGroupSelections(pick, pickErrors, betslipMarketSubTypeLogoService);
    }

    return [];
}

function getBetBuilderPickSelections(pick: BetslipBetBuilderPick): BetBuilderSelectionModel[] {
    if (pick.sportcastOptions?.length) {
        return pick.sportcastOptions;
    }

    return pick.marketName.name.split(';').map((n) => ({ longId: '', name: n }));
}

function getPickGroupSelections(
    pick: BaseBetslipGroupPick,
    pickErrors: IBetslipPickErrors,
    betslipMarketSubTypeLogoService: BetslipMarketSubTypeLogoService,
): BetBuilderSelectionModel[] {
    return pick.getLegs().map((p) => {
        return {
            longId: p.id.toString(),
            name: p.optionName.name,
            details: p.marketName.name,
            hasWarning:
                pick.legIsNoncombinable(p.id) || (pickErrors[p.id.toString()]?.some((t) => t.type === PlacementErrorType.ComboPrevention) ?? false),
            oddsState: pick.getOddsStateForLegId(p.id),
            marketSubTypeSignpostingText: betslipMarketSubTypeLogoService.getMarketSubTypeSignpostingText(p),
        };
    });
}
